import { FlexboxGrid } from "rsuite"
import { TransConfig } from "./settings"
import { ComponentFactory } from "../../../ComponentFactory"
import './styles.scss'

export const TransceiverModalContent = ({state, onChange}: any) => {
  const handleChange = (val: any, id: string, valueID?: string) => {
    onChange({
      val: +val,
      id,
      valueID
    })
  }
  return <>
    {TransConfig.rows.map((component: any) => {
      const id = component.id;
      return <FlexboxGrid className="trans_form" justify="start" align="middle" key={id}>
      <FlexboxGrid.Item colspan={12}>
        {component.isTitle ?  <h6>{component.name}</h6> :  <strong>{component.name}</strong>}
        </FlexboxGrid.Item>
      <FlexboxGrid.Item colspan={12} className="config_section">
        <ComponentFactory
          component={component}
          allState={state}
          componentState={state[id]}
          onChange={(val: any) => handleChange(val, id, component.valueID)}
        />
      </FlexboxGrid.Item>
    </FlexboxGrid>
    })}
  </>
}
